import * as React from "react"

function getText() {
    return <div>
        <h2>Persondatabeskyttelse</h2>
        <p>I henhold til EU’s databeskyttelsesforordning (GDPR) vil vi i det følgende oplyse dig om, hvordan styrelsen håndterer de personoplysninger, som vi modtager og behandler om dig.</p>
        <h3>Vi er dataansvarlig – hvordan kontakter du os?</h3>
        <p>
            Færdselsstyrelsen er dataansvarlig for behandlingen af de personoplysninger, som vi modtager om dig. <br />
            Hvis du har spørgsmål til styrelsens behandling af dine personoplysninger, er du altid velkommen til at kontakte os eller Transport- og Boligministeriets uafhængige databeskyttelsesrådgiver via kontaktoplysningerne nedenfor:
        </p>
        <p>
            <u>Færdselsstyrelsens kontaktoplysninger:</u><br />
            Sorsigvej 35<br />
            6760 Ribe<br />
            Telefon: 7221 8899 <br />
            E-mail: <a href="mailto:info@fstyr.dk">info@fstyr.dk</a><br />
            CVR-nr.: 40850031
        </p>
        <p>
            <u>Databeskyttelsesrådgivers kontaktoplysninger:</u><br />
            E-mail: <a href="mailto:dpo@tbst.dk">dpo@tbst.dk</a><br />
            Telefon: 41780531
        </p>
        {/* END */}
        <h3>Formålene med behandlingen af dine personoplysninger</h3>
        <p>Styrelsen behandler dine personoplysninger til følgende formål:</p>
        <ul>
            <li>Udstedelse af chaufføruddannelsesbevis</li>
            <li>Udstedelse af varebilschaufføruddannelsesbevis</li>
            <li>Herunder også til brug ved et muligt tilsyn</li>
        </ul>
        <p>
            Ved kontrol af køre- og hviletid i et muligt tilsyn af en virksomhed kan personoplysninger blive behandlet ifm. kontrol af overholdelse af køretid, pauser og hviletid.
        </p>
        <p>
            Personoplysningerne kan ligeledes bruges ved et tilsyn til at vurdere, om en virksomhed fortsat opfylder vilkår for, at være indehaver af tilladelser til godskørsel for fremmed regning, eller tilladelser til erhvervsmæssig personbefordring (buskørsel).
        </p>
        <h3>Retsgrundlaget for behandlingen af dine personoplysninger</h3>
        <p>Retsgrundlaget for vores behandling af dine personoplysninger følger af:</p>
        <ul>
            <li>Bekendtgørelse om kvalifikationskrav til visse førere af køretøjer i vejtransport, bekendtgørelse nr. 1327 af 29. november 2017 (med senere ændringer) kap. 5 og 8a</li>
            <li>Europa-Parlamentets og Rådets forordning (EU) nr. 165/2014 af 4. februar 2014 om takografer inden for vejtransport (takografforordningen) artikel 33, stk. 2.</li>
            <li>Europa-Parlamentets og Rådets forordning (EF) nr. 1071/2009 af 21. oktober 2009 om fælles regler om betingelser for udøvelse af vejtransporterhvervet og om ophævelse af Rådets direktiv 96/26/EF art. 12</li>
        </ul>
        <h3>Kategorier af personoplysninger</h3>
        <p>Styrelsen behandler følgende kategorier af personoplysninger om dig:</p>
        <ul>
            <li>Følsomme (CPR-nummer, foto)</li>
            <li>Almindelige (Navn, adresse, fødselsdato, arbejdsområde, arbejdstelefon)</li>
        </ul>
        <p>
            Disse oplysninger kan blive behandlet ved et muligt tilsyn ved kontrol af køre- og hviletid:
            <ul>
                <li>Start- og slutpunkt angivet som gps-koordinater og øvrige gps-koordinater.</li>
            </ul>
        </p>
        <h3>Vi videregiver eller overlader dine personoplysninger til følgende modtagere</h3>
        <ul>
            <li>Skat</li>
            <li>Politi</li>
            <li>Overenskomstparter til den overenskomst du ansættes i henhold til</li>
        </ul>
        <p>
            Udveksling af personoplysninger til ovenstående modtagere sker ifm. vurdering af vandelskrav samt i tilfælde/foranlediget af et muligt tilsyn.
        </p>
        <h3>Hvor dine personoplysninger stammer fra</h3>
        <p>
            Vi behandler de oplysninger, som du afleverer til os i forbindelse med ansøgningen om chaufføruddannelsesbevis eller varebilschaufføruddannelsesbevis.
        </p>
        <h3>Opbevaring af dine personoplysninger</h3>
        <p>Når du logger ind, oprettes du som bruger af systemet og vi opbevarer oplysninger om dig. Så længe du ikke har påbegyndt eller indsendt en ansøgning til os, opbevarer vi dine oplysninger i et begrænset tidsrum, hvorefter vi sletter dem. Påbegyndte og ikke indsendte ansøgninger, som ikke har været aktiveret i 1 år, vil blive forventeligt slettet.</p>
        <p>Vi opbevarer dine personoplysninger i de indsendte ansøgninger i vores sagsbehandlingssystem og sletter dem enten forventeligt 5 år efter den seneste tilladelsens udløb eller sikrer dem via passende foranstaltninger så som pseudonymisering, så personoplysninger ikke længere vil være mulige at henføre til fysiske personer.</p>
        <p>De oplysninger, styrelsen skal journalisere, afleveres løbende til Rigsarkivet efter arkivlovens regler og Statens Arkivers bestemmelser herom. Oplysninger vi modtager, der ikke er omfattet af styrelsens pligt til at journalisere, vil blive slettet.</p>
        <p>Bekendtgørelse af arkivloven LBK 1201 af 28. september 2016 Kapitel 4 aflevering af statslige arkivalier.</p>
        <h3>Dine rettigheder</h3>
        <p>Du har efter databeskyttelsesforordningen en række rettigheder i forhold til vores behandling af oplysninger om dig. Hvis du vil gøre brug af dine rettigheder skal du kontakte os.</p>
        <p>
            <u>Ret til at se oplysninger</u><br />
            Du har ret til at få indsigt i de oplysninger om dig, som vi behandler (indsigtsret), eller til at søge om aktindsigt.
        </p>
        <p>
            <u>Ret til berigtigelse</u><br />
            Du har ret til at få urigtige oplysninger om dig selv rettet.
        </p>
        <p>
            <u>Ret til sletning</u><br />
            I særlige tilfælde har du ret til at få slettet oplysninger om dig, inden tidspunktet for vores almindelige generelle sletning indtræffer. Det gælder alene oplysninger, som ikke er journaliseringspligtige.
        </p>
        <p>
            Du kan læse mere om dine rettigheder i Datatilsynets vejledning om de registreredes rettigheder, som du finder på <a href="http://www.datatilsynet.dk/">www.datatilsynet.dk</a>.
        </p>
        <p>
            <u>Klage til Datatilsynet</u><br />
            Du har ret til at indgive en klage til Datatilsynet, hvis du er utilfreds med den måde, vi behandler dine personoplysninger på. Du finder Datatilsynets kontaktoplysninger på <a href="http://www.datatilsynet.dk/">www.datatilsynet.dk</a>.
        </p>
    </div >
}

export default getText